// extracted by mini-css-extract-plugin
export default {"badge":"GeoFaWidgetBadge_badge__96XUA","label":"GeoFaWidgetBadge_label__ZuTti","icon":"GeoFaWidgetBadge_icon__4TPsC","downloadIcon":"GeoFaWidgetBadge_downloadIcon__sunWt"};